module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('permission-section-card', {
    attrs: {
      "fixedHeight": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(" Profiles Filter")])]), _vm._v(" "), _c('div', [_c('identifier-filter', {
    ref: "identifier",
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "loading": _vm.loadingProfile
    },
    on: {
      "search-profile": function($event) {
        return _vm.$emit('search-profile', $event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n    Utilize the search functionality to identify the target profile\n  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(!_vm.displayProfile) ? _c('permission-profile-browser', {
    attrs: {
      "profiles": _vm.results.profiles,
      "filtered-total": _vm.results.filteredTotal,
      "loadingProfile": _vm.loadingProfile
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c44aef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/PermissionFilterCard.vue
// module id = 3268
// module chunks = 3